import { Kit, KitType } from '@repo/types';
import c from 'classnames';
import { getTextColorFromEvaluationColor } from '@repo/ui';
import { Logo, Typography } from 'components';
import MicrobiomeScoreChart, {
  Legend,
} from 'components/MicrobiomeScoreChart/MicrobiomeScoreChart';
import styles from './MicrobiomeScoreChartContainer.module.css';

type Props = {
  kit: Kit;
  popScore: number;
  color: string;
  showTitle?: boolean;
};

export default function MicrobiomeScoreChartContainer({
  kit,
  popScore,
  color,
  showTitle = true,
}: Props) {
  const isVaginal = kit.sampling_type === KitType.VAGINAL;

  return (
    <div className={styles.titleChartContainer}>
      <div className={styles.titleContainer}>
        {showTitle && (
          <Typography variant='heading-m'>
            {isVaginal ? 'Vaginal microbiome score' : 'Gut microbiome score'}
          </Typography>
        )}
        <div className={c(styles.percentile, styles.margins)}>
          <Typography
            variant='display-l'
            color={getTextColorFromEvaluationColor(color)}
            data-testid='microbiome-score-value'
          >
            {Math.round(popScore)}
          </Typography>
          <span className='dark-grey'> /100</span>
        </div>
      </div>
      <div
        className={c(
          styles.chartContainer,
          'mt-4',
          isVaginal && styles.vaginalChart,
        )}
      >
        <MicrobiomeScoreChart
          kit={kit}
          popScore={popScore}
          bottomLabel='Microbiome Summary Score (MSS)'
        />
        <Logo className={styles.logo} fillHeight />
      </div>
      <div className={c(styles.legendContainer)}>
        <Legend
          isVaginal={isVaginal}
          mode='horizontal'
          gap='1.5rem'
          itemGap='0.5rem'
        />
      </div>
    </div>
  );
}
